module.exports = __webpack_public_path__ + "static/media/SaifeeEvents175.c9279f50.jpg";